import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { Office } from '@/types/office';

export const getStaffOffices = async (
  line_id: string,
  lineAccessToken: string
): Promise<ApiResult<Office[]>> => {
  const { status, result } = await callApiWithoutToken<Office[]>(
    `line/${line_id}/staff/offices`,
    'GET',
    lineAccessToken
  );
  return { status, result };
};
